module.exports = __webpack_public_path__ + "img/ductless_2.d9169d44.png";